import { render } from "./TokenForm.vue?vue&type=template&id=2cd54edd&scoped=true"
import script from "./TokenForm.vue?vue&type=script&lang=js"
export * from "./TokenForm.vue?vue&type=script&lang=js"

import "./TokenForm.vue?vue&type=style&index=0&id=2cd54edd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cd54edd"]])

export default __exports__